import React from 'react';
import { Container, Box } from '@mui/material';
import Canvas from './Canvas';
import LayerPanel from './LayerPanel';
import Toolbar from './ToolbarComponent';

function PaintTool() {
  return (
    <Container maxWidth="xl">
      <Toolbar />
      <Box sx={{ display: 'flex' }}>
        <LayerPanel />
        <Box sx={{ flexGrow: 1 }}>
          <Canvas />
        </Box>
      </Box>
    </Container>
  );
}

export default PaintTool;